import SEOLandingTemplate from './SEOLandingTemplate';

export default function DomainAuthorityPage() {
  return (
    <SEOLandingTemplate
      title="Domain Authority Checker"
      metaTitle="Free Domain Authority Checker | Sungresh"
      metaDescription="Check a domain's authority score, backlink profile, organic traffic, and top competitors in one report, using real DataForSEO data."
      h1="Free Domain Authority Checker"
      sub="A single report combining authority score, backlink counts, organic traffic estimates, and top competing domains — useful for sizing up a site before you invest time targeting it."
      keywords="domain authority checker, check domain authority, authority score checker"
      ctaLink="/domain/overview"
      ctaText="Check a Domain Free"
      features={[
        { icon: '⭐', title: 'Authority Score', desc: 'Overall domain strength estimate' },
        { icon: '🔗', title: 'Backlink Profile', desc: 'Total backlinks and referring domains' },
        { icon: '📈', title: 'Traffic & Keywords', desc: 'Estimated organic traffic and ranking keywords' },
        { icon: '🎯', title: 'Top Competitors', desc: 'Domains competing for the same keywords' },
      ]}
      faqs={[
        { q: 'How is this different from the DA/PA checker?', a: 'This report bundles authority score together with traffic estimates and competitor data for a fuller picture of a domain. The DA/PA checker is a faster, narrower lookup if all you need is the authority number itself.' },
        { q: 'Why might my score differ from what another tool shows?', a: 'Every provider builds its own scoring model from its own backlink index, so the exact number varies by tool. What matters more is tracking your own trend over time and your position relative to competitors, using one tool consistently.' },
        { q: 'What actually moves this number?', a: 'Primarily the quality and diversity of your backlink profile — links from a range of reputable, relevant domains matter more than link volume alone.' },
      ]}
    />
  );
}
